import { apiStaticUrlGet } from "common/api/api_common";
import {
  PHOTO_SIZE_TYPE,
  PhotoSizeType,
} from "constant/photo_series/photo_series.constant";
import ObjCommon from "model/common/ObjCommon";

export type PhotoTag = {
  top: number;
  left: number;
  imH: number;
  imW: number;
  val: string;
};

export type PhotoFileds = {
  name: string;
  small: string;
  middle: string;
  desc: string;
  ord: number;
  tag: PhotoTag[];
};

export class PhotoSeries extends ObjCommon {
  name: string = "";
  slug: string = "";
  desc: string = "";
  group: string = "";
  represent: PhotoFileds | null = null;
  sType: string = "";
  sOrd: number = 0;
  fold: string = "";
  photos: PhotoFileds[] = [];

  constructor(args: Partial<PhotoSeries> = {}) {
    super(args?.id);

    this.name = args?.name ?? "";
    this.slug = args?.slug ?? "";
    this.desc = args?.desc ?? "";
    this.group = args?.group ?? "";
    this.represent = args?.represent ?? null;
    this.sType = args?.sType ?? "";
    this.sOrd = args?.sOrd ?? 0;
    this.fold = args?.fold ?? "";
    this.photos = args?.photos ?? [];
  }

  getShortSType(): string {
    return this.sType === "fotografije" ? "ph" : "ng";
  }

  getRepresents(): string[] {
    let photoN: string[] = [];
    if (this.represent !== null && this.represent.middle) {
      photoN.push(this.represent.middle);
    }
    const maxN = Math.min(4, this.photos.length);
    for (let i = 0; i < maxN; i++) {
      const ph = this.photos[i].small;
      if (
        !photoN.includes(this.photos[i].name) &&
        !photoN.includes(this.photos[i].middle) &&
        !photoN.includes(this.photos[i].small)
      ) {
        photoN.push(ph);
      }
      if (photoN.length >= maxN) {
        break;
      }
    }

    return photoN;
  }

  getPhotoStaticUrl(ind: number, sizeType: PhotoSizeType): string {
    const photoTypeKey = sizeType !== PHOTO_SIZE_TYPE.LARGE ? sizeType : "name";
    const url = apiStaticUrlGet(
      `photo-series/${this.fold}/${this.photos[ind][photoTypeKey]}`
    );
    return url;
  }
}
